exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-book {\n\ttext-align: center;\n        margin-top:7em;\n}\n\n/*#home-book > h4 {\n\tmargin-bottom: 1em;\n}*/\n\n#home-book > h4:hover {\n\tcursor: pointer;\n}\n\n#home-book-form {\n\toverflow: hidden;\n}\n.thetitle {\n\tfont-weight: 400;\n        text-align:center;\n        padding-bottom:10px;\n        font-family: \"Great Vibes\"!important;\n\tfont-size: 56px;\n\tcolor:#c59d5f;\n\n}\n/* .thetitle {\n\tfont-weight: 700;\n\tfont-size:32px;\n\tfont-family: \"Fredoka One\";\n\tcolor: gold;\n        text-align:center;\n        padding-bottom:10px;\n}\n.subtitle {\n\tfont-family: \"Dosis\";\n\tfont-size: 18px;\n\tfont-style: oblique;\n\t}\n\t\n.bodysection {\n\tfont-family: Dosis;\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/book.component.css
// module id = ../../../../../src/app/book.component.css
// module chunks = main